import { AppUser, MediaHistoryItem, TabType } from '../types';
import { HomeTab } from '../features/posts/HomeTab';

interface FeedTabProps {
  mediaHistory?: MediaHistoryItem[];
  onOpenAuth: () => void;
  currentUser?: AppUser | null;
  onTabChange?: (tab: TabType) => void;
  onOpenProfile?: (uid: string) => void;
}

export const FeedTab = ({
  mediaHistory,
  onOpenAuth,
  currentUser,
  onTabChange,
  onOpenProfile
}: FeedTabProps) => (
  <HomeTab
    mediaHistory={mediaHistory}
    currentUser={currentUser}
    onOpenAuth={onOpenAuth}
    onTabChange={onTabChange}
    onOpenProfile={onOpenProfile}
  />
);
